<template>
  <InputSwitch id="show-info" v-model="showPaymentInfo" @click.stop>
    <template #valueText> {{ translate(`${LOCALE_PREFIX}.form.showInfo`) }} </template>
  </InputSwitch>
</template>

<script setup lang="ts">
import { InputSwitch } from '@centric-os/components/src/core/controls/input-switch';
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { usePaymentInfoStore } from '../../../../../../routes';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_PAYMENT_INFO;

// Set payment info store
const paymentInfoStore = usePaymentInfoStore();
const { showPaymentInfo } = storeToRefs(paymentInfoStore);
</script>
